let changeValueOptions = ((id, key, json) => {
  let selectField = document.querySelector(`#${id}`)
  if (!selectField) return;

  let selectOptions = optionElement('')
  let jsonOptions = JSON.parse(json)


  if (key){
    selectOptions += populateOptionsField(key, jsonOptions)
  } else {
    let jsonKeys = Object.getOwnPropertyNames(jsonOptions)

    jsonKeys.forEach((jsonKey) => {
      selectOptions += populateOptionsField(jsonKey, jsonOptions)
    })
  }

  selectField.options.length = 0;
  selectField.innerHTML = selectOptions
})

let optionElement = ((option = '') => {
  return `<option value="${option}">${option}</option>`
})

let populateOptionsField = ((key, json) => {
  return json[key].map(option => optionElement(option))
})

export { changeValueOptions }
